import React from "react";
import ForRentCostumesList from "./for-rent-costumes-list/for-rent-costumes-list";

const ForRentCostumesContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForRentCostumesList/>
            </div>
        </>
    )
};

export default ForRentCostumesContainer;